import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCompass, FaChevronDown } from "react-icons/fa6";

/**
 * Bottom-of-path "Explore other courses" card. Locked ("Complete this course to
 * unlock") until the current course is finished, then pressable → Courses tab.
 * Shared by the regular course path (ChapterPathList) and the Flight School path
 * (FlightSchoolHomePath) so the two stay in sync.
 */
const ExploreOtherCoursesCard: React.FC<{ completed: boolean }> = ({
  completed,
}) => {
  const navigate = useNavigate();

  if (completed) {
    return (
      <button
        type="button"
        onClick={() => navigate("/home/courses")}
        className="flex flex-row items-center w-full p-4 bg-white rounded-2xl border border-[var(--color-grey-light)] shadow-sm active:opacity-80"
      >
        <div className="w-8 h-8 rounded-full bg-[var(--color-grey-lightest)] flex items-center justify-center mr-3.5">
          <FaCompass className="w-4 h-4 text-[var(--color-green)]" />
        </div>
        <div className="flex flex-col flex-1 text-left">
          <span className="text-base font-bold text-[var(--color-text-primary)]">
            Explore other courses
          </span>
          <span className="text-[11px] font-medium text-[var(--color-grey)]">
            Course complete!
          </span>
        </div>
        <FaChevronDown className="w-3.5 h-3.5 -rotate-90 text-[var(--color-grey-other)]" />
      </button>
    );
  }

  return (
    <div className="flex flex-row items-center w-full p-4 bg-white rounded-2xl border border-[var(--color-grey-light)] opacity-50">
      <div className="w-8 h-8 rounded-full bg-[var(--color-grey-lightest)] flex items-center justify-center mr-3.5">
        <FaCompass className="w-4 h-4 text-[var(--color-grey-other)]" />
      </div>
      <div className="flex flex-col flex-1">
        <span className="text-base font-semibold text-[var(--color-grey)]">
          Explore other courses
        </span>
        <span className="text-[11px] text-[var(--color-grey)]">
          Complete this course to unlock
        </span>
      </div>
    </div>
  );
};

export default ExploreOtherCoursesCard;
